import { r as registerInstance, c as createEvent, h, g as getElement } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import './index-e29b327a.js';
import { P as PesRoute } from './pes-route-5a1043d8.js';
import { P as PesProductLink } from './pes-product-link-74e48119.js';
import { z as html2plain } from './helpers-c4d5ad02.js';
import { s as send, m as productVariantsClickEvent } from './analytics-b6a65ffa.js';
import './_commonjsHelpers-11ca3be1.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './pes-router-store-0c1092be.js';
import './index-54dd34b7.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './helpers-e12aa36b.js';
import './_isIndex-3036d479.js';
import './toNumber-6e3a0b09.js';
import './isSymbol-bae590b5.js';
import './index-e233ecdd.js';
import './isEmpty-51908328.js';
import './toString-10b0f228.js';
import './number-57a50dcb.js';

const productVariantsCss = ":host .product-variants .product-variants__row{margin-bottom:5px}:host .product-variants .product-variants__row.dropdown{margin-bottom:15px}:host .product-variants .product-variants__row p{font-weight:bold;margin-top:0;margin-bottom:10px}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row p{text-align:left}:host([dir=\"rtl\"]) .product-variants .product-variants__row p{text-align:right}:host .product-variants .product-variants__row .links{display:flex;align-content:flex-start;flex-direction:row;flex-wrap:wrap}:host .product-variants .product-variants__row .links .green{font-size:0.875rem;font-weight:normal;line-height:20px;margin-bottom:10px;padding:4px 8px;cursor:default;text-decoration:none;color:#ffffff;border:1px solid #3dcd58;border-radius:15px;background:#3dcd58;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row .links .green{margin-right:10px}:host([dir=\"rtl\"]) .product-variants .product-variants__row .links .green{margin-left:10px}:host .product-variants .product-variants__row .links pes-router-link{margin-bottom:10px;overflow:hidden}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row .links pes-router-link{margin-right:10px}:host([dir=\"rtl\"]) .product-variants .product-variants__row .links pes-router-link{margin-left:10px}:host .product-variants .product-variants__row .links pes-router-link a{font-size:0.875rem;font-weight:normal;line-height:20px;display:block;padding:4px 8px;text-decoration:none;border:1px solid;border-radius:15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;transition:0.3s}:host .product-variants .product-variants__row .links pes-router-link.simple a{color:#626469;border-color:#cbcbcb;background:#ffffff}:host .product-variants .product-variants__row .links pes-router-link.simple a:hover{border-color:#626469}:host .product-variants .product-variants__row .links pes-router-link.dash a{color:#cbcbcb;border-style:dashed;border-color:#cbcbcb;background:#ffffff}:host .product-variants .product-variants__row .links pes-router-link.dash a:hover{color:#626469;border-style:solid;border-color:#626469}";

const OLD_ACTIVE_ITEM = 'green';
const ACTIVE_ITEM = 'selected';
const PesProductVariants = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesLinkClick = createEvent(this, "pesLinkClick", 7);
    this.onProductVariantsSelect = (productIdOrUrl) => {
      var _a;
      if (this.isVariantsNew) {
        let char;
        let charId;
        let itemCount;
        if ((_a = this.variantsData) === null || _a === void 0 ? void 0 : _a.chars) {
          for (const el of this.variantsData.chars) {
            char = el.variants.find((variant) => this.getIdOrUrl(variant) === productIdOrUrl);
            if (char !== undefined) {
              charId = el.charId;
              itemCount = el.variants.findIndex((variant) => this.getIdOrUrl(variant) === productIdOrUrl);
              break;
            }
          }
        }
        send(productVariantsClickEvent, {
          brand: char.brand,
          category: this.variantsData.groupId,
          id: char.productId,
          name: char.valueId,
          position: itemCount + 1,
          price: char.price,
          variant: charId,
          currency: char.currency,
        });
      }
    };
    this.variants = undefined;
    this.enableAppRouting = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  selectedValue(event) {
    this.onProductVariantsSelect(event.detail.selectedValue);
    this.navigate({ page: 'product', pageId: event.detail.selectedValue });
  }
  navigate({ page, pageId }) {
    if (this.enableAppRouting) {
      const hostRef = new PesRoute({ page, pageId }).url;
      this.pesLinkClick.emit({ page, pageId });
      document.location.href = hostRef;
    }
    else {
      document.location.href = pageId;
    }
  }
  getIdOrUrl(variant) {
    return this.enableAppRouting ? variant.productId : variant.url;
  }
  validateSelectData(data) {
    const selectData = [];
    data.forEach((variant) => {
      selectData.push({
        value: this.getIdOrUrl(variant),
        label: variant.value,
        selected: this.isActiveVariantType(variant.type),
      });
    });
    return selectData;
  }
  isActiveVariantType(variantType) {
    return variantType === OLD_ACTIVE_ITEM || variantType === ACTIVE_ITEM;
  }
  showLinks(data) {
    return (h("div", { class: "links" }, data.map((variant) => {
      if (this.isActiveVariantType(variant.type)) {
        return (h("div", { class: "green", title: html2plain(variant.value), innerHTML: variant.value }));
      }
      return (h(PesProductLink, { className: variant.type, url: variant.url, id: variant.productId, enableAppRouting: this.enableAppRouting }, h("a", { href: variant.url, title: html2plain(variant.value), onClick: () => this.onProductVariantsSelect(this.getIdOrUrl(variant)), innerHTML: variant.value })));
    })));
  }
  componentWillLoad() {
    this.isVariantsNew = this.variants.hasOwnProperty('chars');
    this.variantsData = this.isVariantsNew ? this.variants : { chars: this.variants };
  }
  render() {
    var _a, _b, _c;
    if (!((_a = this.variantsData) === null || _a === void 0 ? void 0 : _a.chars)) {
      return null;
    }
    return (h("div", { class: "product-variants" }, (_c = (_b = this.variantsData) === null || _b === void 0 ? void 0 : _b.chars) === null || _c === void 0 ? void 0 : _c.map((item) => {
      return (h("div", { class: classnames('product-variants__row', { dropdown: item.dropdown }) }, h("p", null, item.title, ":"), item.dropdown ? (h("pes-select", { items: this.validateSelectData(item.variants) })) : (this.showLinks(item.variants))));
    })));
  }
  get el() { return getElement(this); }
};
PesProductVariants.style = productVariantsCss;

export { PesProductVariants as pes_product_variants };
